/** Iconos pequenyos compartidos por varias pantallas, en linea para no depender de nada. */

export function IconoCheck({ size = 14 }: { size?: number }): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M5 12l5 5L20 7" />
    </svg>
  );
}

/** Un icono por motivo de baja (retención, 18 oct 2026). Mismo trazo que el menú. */
const TRAZO_MOTIVO: Record<string, string> = {
  price: 'M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8ZM7.5 7.5h.01',
  time: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM12 7v5l3 2',
  difficult: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.7.3-1 .8-1 1.5v.2M12 17h.01',
  missing: 'M5 4h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1ZM12 8v8M8 12h8',
  closed: 'M3 9l1.5-5h15L21 9M4 9h16v11H4ZM9 20v-6h6v6',
  other: 'M21 12a8 8 0 0 1-8 8H4l2-3a8 8 0 1 1 15-5ZM8.5 12h.01M12 12h.01M15.5 12h.01',
};

export function IconoMotivo({ motivo, size = 18 }: { motivo: string; size?: number }): JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d={TRAZO_MOTIVO[motivo] ?? TRAZO_MOTIVO.other} />
    </svg>
  );
}
